import { render, staticRenderFns } from "./item-wrap.vue?vue&type=template&id=6d509bdc"
import script from "./item-wrap.vue?vue&type=script&lang=js"
export * from "./item-wrap.vue?vue&type=script&lang=js"
import style0 from "./item-wrap.vue?vue&type=style&index=0&id=6d509bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports